export default __webpack_public_path__ + "static/media/Schwein-im-Heu.1d0f0a14.webp";